function parseCsrf() {
  var _document$querySelect, _document, _document$querySelect2;

  return (_document$querySelect = (_document = document) === null || _document === void 0 ? void 0 : (_document$querySelect2 = _document.querySelector('meta[name=csrf-token]')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.getAttribute('content')) !== null && _document$querySelect !== void 0 ? _document$querySelect : undefined;
}

export default parseCsrf;